import req from '../utils/request'
/**
 * 语料库
 */
// 获取语料库列表
export function libraryListAPI(params) {
    return req.get('/prod-api/questionLibrary/libraryList',params)
}
export function libraryList(page,size) {
    return req.get(`/prod-api/questionLibrary/libraryList?page=${page}&size=${size}`)
}
// 设为默认库
export function updateDefaultAPI(libraryId) {
    return req.putType(`/prod-api/questionLibrary/updateDefault?libraryId=${libraryId}`)
}
// 复制语料库
export function copyLibraryAPI(query) {
    return req.postQuery('/prod-api/questionLibrary/copyLibrary',query)
}
// 新增语料库
export function createLibraryAPI(query) {
    return req.post('/prod-api/questionLibrary/createLibrary',query)
}
// 删除语料库
export function deleteLibraryAPI(libraryId) {
    return req.delete(`/prod-api/questionLibrary/deleteLibrary?libraryId=${libraryId}`)
}
// 修改语料库
export function updateLibraryAPI(query) {
    return req.put('/prod-api/questionLibrary/updateLibrary',query)
}
// 修改语料库名称
export function updateTitleAPI(query) {
    return req.putType('/prod-api/questionLibrary/updateTitle',query)
}
// 语料库详情
export function libraryDetailAPI(params) {
    return req.get('/prod-api/questionLibrary/libraryDetail',params)
}
/**
 * 语料库互动
 */
// 获取互动列表
export function answerListAPI(params) {
    return req.get('/prod-api/questionAnswer/answerList',params)
}
// 新增互动
export function createAnswerAPI(query) {
    return req.post('/prod-api/questionAnswer/createAnswer',query)
}
// 互动详情
export function answerDetailAPI(params) {
    return req.get('/prod-api/questionAnswer/answerDetail',params)
}
// 设置生效状态
export function updateCheckedAPI(answerChecked,answerId) {
    return req.put(`/prod-api/questionAnswer/updateChecked?answerChecked=${answerChecked}&answerId=${answerId}`)
}
// 删除互动
export function deleteAnswerAPI(answerId) {
    return req.delete(`/prod-api/questionAnswer/deleteAnswer?answerId=${answerId}`)
}
// 编辑互动
export function updateAnswerAPI(query) {
    return req.putQuery('/prod-api/questionAnswer/updateAnswer',query)
}
// 删除互动附件

export function deleteattachAPI(attachId) {
    return req.delete(`/prod-api/questionAnswer/deleteAnswerAttach?attachId=${attachId}`)
}

// 获取用户信息
export function getProfileAPI(params) {
    return req.get('/prod-api/member/profile',params)
}
// 修改用户手机号
export function updateMobileAPI(query) {
    return req.putQuery('/prod-api/member/updateMobile',query)
}

// 修改用户密码
export function updatePasswordAPI(query) {
    return req.putQuery('/prod-api/member/updatePassword',query)
}
// 发送手机验证码
export function sendVerifyCodeAPI(query) {
    return req.postQuery('/prod-api/member/verifyCode',query)
}

// 修改头像
export function updateAvatarAPI(avatar) {
    return req.put(`/prod-api/member/updateAvatar?avatar=${avatar}`)
}

// 修改用户信息
export function updateProfileAPI(query) {
    return req.putQuery('/prod-api/member/updateProfile',query)
}


// 获取未匹配问题列表
export function getMisMatchListAPI(params) {
    return req.get('/prod-api/questionAiChat/misMatchList',params)
}
// 获取未匹配问题列表2.0
export function getUnMatchListAPI(params) {
    return req.get('/prod-api/questionAiChat/unMatchList',params)
}

// 删除未匹配问题
export function deleteMisMatchrAPI(chatId) {
    return req.delete(`/prod-api/questionAiChat/deleteMisMatch?chatId=${chatId}`)
}
// 删除未匹配问题2.0
export function deleteUnMatchrAPI(chatId) {
    return req.delete(`/prod-api/questionAiChat/deleteUnMatch?chatId=${chatId}`)
}

// 互动历史记录
export function getHistoryListAPI(params) {
    return req.get('/prod-api/questionAiChat/historyList',params)
}
// 删除历史记录
export function deleteChatAPI(chatId) {
    return req.delete(`/prod-api/questionAiChat/deleteChat?chatId=${chatId}`)
}

/**
 * 互动数字人应用
 */

// 获取模特列表
export function getModelListAPI(params) {
    return req.get('/prod-api/questionApplication/modelList',params)
}
//  创建数字人应用(post)
export function createHumanAPI(query) {
    return req.post('/prod-api/questionApplication/createApplication',query)
}

//  删除数字人应用(delete)
export function deleteHumanAPI(appId) {
    return req.delete(`/prod-api/questionApplication/deleteApplication?appId=${appId}`)
}
//  数字人应用详情(get)
export function gethumanDetailAPI(params) {
    return req.get('/prod-api/questionApplication/applicationDetail',params)
}

//  数字人应用列表(get)
export function gethumanListAPI(params) {
    return req.get('/prod-api/questionApplication/applicationList',params)
}

//  编辑数字人应用(put)
export function updateHumanAPI(query) {
    return req.putQuery('/prod-api/questionApplication/updateApplication',query)
}


export function uploadVoiceAPI(query) {
    return req.post('/prod-api/question/uploadVoice',query)
}


// 数字人背景列表
export function getbackgroundListAPI(params) {
    return req.get('/prod-api/questionBackground/backgroundList',params)
}
/**
 * 高级知识库模块
 */

// 获取高级知识库列表
export function sLibraryListAPI(params) {
    return req.get('/prod-api/questionLibraryAdvanced/libraryList',params)
}
// 删除高级知识库
export function deleteSLibrarys(libraryId) {
    return req.delete(`/prod-api/questionLibraryAdvanced/deleteLibrary?libraryId=${libraryId}`)
}
